import { Seo } from "@/components/Seo";

const H2 = ({ children }) => (
  <h2 className="mt-10 text-xl font-bold text-ink">{children}</h2>
);

export default function PolitiqueConfidentialite() {
  return (
    <div className="bg-white pb-24 pt-32" data-testid="politique-confidentialite-page">
      <Seo
        title="Politique de confidentialité — Syndicappli360"
        description="Politique de confidentialité du site Syndicappli360 : données collectées, finalités, durée de conservation et vos droits."
        path="/politique-de-confidentialite"
      />
      <div className="mx-auto max-w-3xl px-6 lg:px-10">
        <span className="inline-flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-electric">
          <span className="h-px w-10 bg-electric" />
          RGPD
        </span>
        <h1 className="mt-5 text-4xl font-bold tracking-normal leading-[1.15] text-ink md:text-5xl">
          Politique de confidentialité
        </h1>

        <H2>Responsable du traitement</H2>
        <p className="mt-3 text-sm leading-relaxed text-ink/70">
          Syndicappli — 6, rue Léonard De Vinci, CS 20119, 53001 Laval —
          contact@syndicappli.fr — +33 7 55 60 85 50.
        </p>

        <H2>Données collectées</H2>
        <p className="mt-3 text-sm leading-relaxed text-ink/70">
          Le site collecte uniquement les données que vous transmettez
          volontairement :
        </p>
        <ul className="mt-3 list-disc space-y-2 pl-5 text-sm leading-relaxed text-ink/70">
          <li>
            via le formulaire de contact : nom, adresse email, numéro de
            téléphone (facultatif) et message ;
          </li>
          <li>
            via l'assistant en ligne : vos messages de conversation.
          </li>
        </ul>

        <H2>Finalités et base légale</H2>
        <p className="mt-3 text-sm leading-relaxed text-ink/70">
          Ces données servent exclusivement à répondre à votre demande,
          assurer le suivi des échanges et vous orienter vers une
          démonstration si vous le souhaitez. Elles ne sont ni vendues, ni
          cédées, ni utilisées pour de la prospection non sollicitée.
        </p>

        <H2>Destinataires et conservation</H2>
        <p className="mt-3 text-sm leading-relaxed text-ink/70">
          Les messages sont transmis à l'équipe Syndicappli
          (contact@syndicappli.fr) et conservés dans une base de données
          sécurisée pendant la durée nécessaire au traitement de votre
          demande. L'envoi d'emails transite par un prestataire technique
          d'acheminement.
        </p>

        <H2>Cookies et traceurs</H2>
        <p className="mt-3 text-sm leading-relaxed text-ink/70">
          Ce site n'utilise pas de cookies de mesure d'audience, ni de
          cookies publicitaires, ni de traceurs non essentiels : aucun bandeau
          de consentement n'est donc nécessaire. Le chargement de la police
          de caractères (Google Fonts) transmet des données techniques
          (dont votre adresse IP) aux serveurs de Google lors de l'affichage.
        </p>

        <H2>Vos droits</H2>
        <p className="mt-3 text-sm leading-relaxed text-ink/70">
          Conformément au RGPD, vous disposez de droits d'accès, de
          rectification, d'effacement et d'opposition sur vos données. Pour
          les exercer, écrivez à contact@syndicappli.fr. Vous pouvez également
          saisir la CNIL (cnil.fr) en cas de litige.
        </p>

        <H2>Sécurité</H2>
        <p className="mt-3 text-sm leading-relaxed text-ink/70">
          Les échanges avec le site sont chiffrés (HTTPS) et l'accès aux
          données stockées est restreint à l'équipe de l'éditeur.
        </p>
      </div>
    </div>
  );
}
